// Borrador local de planeaciones (respaldo en el navegador).
// Sobrevive aunque al docente lo saquen, se cierre sesión o se caiga la red:
// mientras el guardado al servidor no confirme, el borrador queda aquí para recuperarlo.
const PREFIX = "uaic_plandraft:";

export function saveDraft(key, payload) {
  try {
    localStorage.setItem(PREFIX + key, JSON.stringify({ ...payload, _ts: Date.now() }));
  } catch { /* almacenamiento lleno o bloqueado: ignorar */ }
}

export function readDraft(key) {
  try {
    const v = localStorage.getItem(PREFIX + key);
    return v ? JSON.parse(v) : null;
  } catch {
    return null;
  }
}

export function clearDraft(key) {
  try {
    localStorage.removeItem(PREFIX + key);
  } catch { /* ignorar */ }
}

export function draftAgeLabel(ts) {
  if (!ts) return "";
  const s = Math.max(0, Math.floor((Date.now() - ts) / 1000));
  if (s < 60) return "hace unos segundos";
  const m = Math.floor(s / 60);
  if (m < 60) return `hace ${m} min`;
  const h = Math.floor(m / 60);
  if (h < 24) return `hace ${h} h`;
  const d = Math.floor(h / 24);
  return `hace ${d} d`;
}
